import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { EnderecoDTO } from 'app/components/recadastramento-aba4/endereco.dto';
import { EnderecoAba4Service } from 'app/service/endereco-aba4/endereco.service';
import { ToastrService } from 'ngx-toastr';
import { EnumService } from 'app/service/enum/enum';
import { Enum } from 'app/model/enum';
import { Ufs } from "../../model/Ufs";
import { LocalidadesIbgeService } from "../../service/localidades-ibge/localidades-ibge.service";
import { EnderecoViaCep } from "../../service/enderecoViaCep/enderecoViaCep.service";
import { forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MunicipioDTO } from 'app/model/municipio.dto';
import { saveAs } from 'file-saver';
import { tipoLogradouroDTO } from 'app/model/tipoLogradouro.dto';
import { MaskUtil } from "../../utils/mask-util";


@Component({
  selector: 'app-recadastramento-aba4',
  templateUrl: './recadastramento-aba4.component.html',
  styleUrls: ['./recadastramento-aba4.component.sass']
})

export class RecadastramentoAba4Component implements OnInit, OnChanges {
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild('fileInputEndereco') fileInputEndereco!: ElementRef;

  form: FormGroup;
  user: DadosPessoaisAba1Response = null;
  arquivoSelecionadoEndereco: File;
  endereco: EnderecoDTO[];
  descLogradouroOriginal: string;
  numeroLogradouroOriginal: number;
  codTipoLogradouroOriginal: string;
  descComplementoLogradouroOriginal: string;
  descBairroOriginal: string;
  numeroCepLogradouroOriginal: number;
  descricaoMunicipioLogradouroOriginal: string;
  codMunicipioLogradouro: number;
  codUfLogradouroOriginal: string;
  municipios: MunicipioDTO[];
  isInfoImportantVisible: boolean = true;
  ufs: Enum[];
  enderecoApi: any;
  isLoadingSpinner: boolean = true;
  municipiosFiltrados: MunicipioDTO[];
  arquivoEnviadoEndereco: boolean = false;
  tiposLogradouros: Enum[];
  tipoLogradouroOriginal: string
  numeroCepLogradouroControl = new FormControl();
  existeAnexoInicial: boolean = false;
  enviandoAnexoEstadoCivil: boolean = false;
  arquivoEnderecoAnexado: boolean = true;
  public filteredOptions: any[] = [];
  public options: any[] = [];
  existDiff: boolean = false;

  constructor(
    // private dadosPessoaisAba1: DadosPessoaisAba1,
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private enumService: EnumService,
    private enderecoService: EnderecoAba4Service,
    private enderecoViaCep: EnderecoViaCep,
    private localidadesIbgeService: LocalidadesIbgeService,
  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.form = this.formBuilder.group({
      descLogradouro: ['', [Validators.required]],
      //descTipoLogradouro: ['', [Validators.required]],
      numeroLogradouro: ['', [Validators.required]],
      descComplementoLogradouro: [''],
      descBairro: ['', [Validators.required]],
      numeroCepLogradouro: ['', [Validators.required]],
      descricaoMunicipioLogradouro: [{ value: '', disabled: true }, [Validators.required]],
      codMunicipioLogradouro: [''],
      codUfLogradouro: ['', [Validators.required]],
      codTipoLogradouro: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    /*this.form.get('numeroCepLogradouro').valueChanges.subscribe(() => {
      this.buscarCep();
    });*/
    this.processarEndereco();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  getOpcoesAutoComplete(event: any) {
    this.form.controls['codMunicipioLogradouro'].setValue(null);
    let municipio: string = event.target.value;
    this.enderecoService.getOpcoesAutoComplete(municipio).subscribe(resp => {
      //console.log(resp)
      this.options = resp.content;

      this.filteredOptions = this.options.filter((option) =>

        option.descricao.toUpperCase().includes(municipio.toLowerCase())

        );

    })
  }

  public onOptionSelected(option: any): void {
    this.form.controls['codMunicipioLogradouro'].setValue(option.codigo);
  }

  private processarEndereco(): void {

    this.isLoadingSpinner = true;
    const endereco$: Observable<EnderecoDTO> = this.getEndereco();

    const ufs$: Observable<Enum[]> = this.getUfs();
    const tipoLogradouro$: Observable<Enum[]> = this.buscarTipoLogradouro();
    forkJoin([endereco$, ufs$, tipoLogradouro$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([endereco, ufs, tipoLogradouro]) => {
          // Manipular os dados do endereço e UFs aqui
          //this.buscarTipoLogradouro()
          //this.buscarMunicipio();

          this.atualizarFormulario(endereco, ufs, tipoLogradouro);

        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }

  private getEndereco(): Observable<EnderecoDTO> {
    return this.enderecoService.getEnderecoPessoal();
  }

  private getUfs(): Observable<Enum[]> {
    return this.enumService.buscarUF();
  }

  private buscarTipoLogradouro(): Observable<Enum[]> {
    return this.enumService.buscarTipoLogradouro();
  }

  private atualizarFormulario(endereco: EnderecoDTO, ufs: Enum[], tipoLogradouro: Enum[]): void {
    this.arquivoEnviadoEndereco = endereco.anexoEndereco;
    this.existeAnexoInicial = endereco.anexoEndereco;
    this.tipoLogradouroOriginal = endereco.descLogradouro;
    this.descLogradouroOriginal = endereco.descLogradouro;
    this.numeroCepLogradouroOriginal = endereco.numeroCepLogradouro;
    this.codTipoLogradouroOriginal = endereco.codTipoLogradouro.trim();
    this.numeroLogradouroOriginal = endereco.numeroLogradouro;
    this.descComplementoLogradouroOriginal = endereco.descComplementoLogradouro;
    this.descBairroOriginal = endereco.descBairro;
    this.descricaoMunicipioLogradouroOriginal = endereco.descricaoMunicipioLogradouro;
    this.codMunicipioLogradouro = endereco.codMunicipioLogradouro;
    this.codUfLogradouroOriginal = endereco.codUfLogradouro;

    this.form.patchValue({
      descLogradouro: endereco.descLogradouro,
      numeroLogradouro: endereco.numeroLogradouro,
      descComplementoLogradouro: endereco.descComplementoLogradouro,
      descBairro: endereco.descBairro,
      numeroCepLogradouro: endereco.numeroCepLogradouro,
      descricaoMunicipioLogradouro: endereco.descricaoMunicipioLogradouro,
      codMunicipioLogradouro: endereco.codMunicipioLogradouro,
      codUfLogradouro: endereco.codUfLogradouro,
      codTipoLogradouro: endereco.codTipoLogradouro.trim(),
    });
    this.tiposLogradouros = tipoLogradouro
    this.ufs = ufs;
  }

  checkDiffCep($event: any) {
    const numeroCepLogradouro = $event.target.value.replace(/\D/g, '');

    if (numeroCepLogradouro.length === 8) {
      if (this.numeroCepLogradouroOriginal !== numeroCepLogradouro) {
        this.buscarCep();
      }
    }
  }

  buscarCep(): void {
    const numeroCepLogradouro = this.form.get('numeroCepLogradouro').value;
    this.form.controls['descricaoMunicipioLogradouro'].disable();

    this.enderecoViaCep.buscarEnderecoViaCep(numeroCepLogradouro).subscribe(
      (data: any) => {
        this.enderecoService.getVerificarMunicioValido(data.localidade, data.uf).subscribe(
          (resp: any) => {
            this.form.patchValue({
              descLogradouro: this.validarCampo(data.logradouro),
              descBairro: this.validarCampo(data.bairro),
              codUfLogradouro: data.uf,
              descricaoMunicipioLogradouro: this.validarCampo(resp.descricao),
              codMunicipioLogradouro: resp.codigo
            });

          },
          (err) => {
            this.toasterService.error('CEP inválido');
            this.form.controls['descricaoMunicipioLogradouro'].setValue('');
            this.form.controls['descricaoMunicipioLogradouro'].enable();
          }
        );
      }
    );

  }

  filtrarMunicipiosPorLocalidade(localidade: string) {
    const localidadeLowerCase = localidade.toLowerCase(); // Converter para letras minúsculas
    const localidadeMunicipio = this.municipios.find(municipio => municipio.descricao.toLowerCase() === localidadeLowerCase);
    return localidadeMunicipio ? localidadeMunicipio.codigo : null;
  }

  visualizarComprovanteEndereco(): void {
    this.enderecoService.getArquivo().subscribe((response: Blob) => {
      const fileName = 'Comprovante_Endereco';
      const fileType = this.getFileTypeFromBlob(response);
      if (fileType === null) {
        return;
      }

      const blob = new Blob([response], { type: fileType });
      // Inicia o download do arquivo
      saveAs(blob, fileName + '.' + fileType);
    }, error => {
      this.toasterService.warning('Erro ao fazer o download do arquivo');
    });
  }

  private getFileTypeFromBlob(blob: Blob): string | null {
    if (blob.type) {
      const contentType = blob.type.toLowerCase();
      if (contentType.includes('pdf')) {
        return 'pdf';
      } else if (contentType.includes('jpeg') || contentType.includes('jpg')) {
        return 'jpeg';
      } else if (contentType.includes('png')) {
        return 'png';
      }
    }
    return null;
  }

  extractFileName(contentDispositionHeader: string): string {
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(contentDispositionHeader);
    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
    return '';
  }

  extractFileExtension(fileName: string): string {
    const fileExtensionRegex = /(?:\.([^.]+))?$/;
    const matches = fileExtensionRegex.exec(fileName);
    if (matches != null && matches[1]) {
      return matches[1].toLowerCase();
    }
    return '';
  }

  checkCEP() {
    if (this.numeroCepLogradouroOriginal != this.form.value.numeroCepLogradouro) {
      return true
    } else {
      return false
    }
  }

  checkTipoLogradouro() {
    if (this.codTipoLogradouroOriginal != this.form.value.codTipoLogradouro) {
      return true
    } else {
      return false
    }
  }

  checkDescLogradouro() {
    const descLogradouro = this.form.get('descLogradouro') as FormControl;
    const value = descLogradouro.value;

    if (value.length > 80) {
      descLogradouro.setErrors({ maxlength: true });
    } else {
      descLogradouro.setErrors(null);
    }

    const descricaologradouro = this.form.value.descLogradouro
    if (this.descLogradouroOriginal != descricaologradouro) {
      return true
    } else {
      return false
    }

  }

  checkNumLogradouro() {
    const numerologradouro = this.form.value.numeroLogradouro
    const numeroLogradouroCtrl = this.form.get('numeroLogradouro') as FormControl;
    const value = numeroLogradouroCtrl.value;

    if (value.toString().length > 10) {
      numeroLogradouroCtrl.setErrors({ maxlength: true });
    } else {
      numeroLogradouroCtrl.setErrors(null);
    }

    if ((this.numeroLogradouroOriginal) != (numerologradouro)) {
      return true;
    } else {
      return false;
    }
  }

  checkDescBairro() {
    const bairro = this.form.value.descBairro

    const descBairroCtrl = this.form.get('descBairro') as FormControl;
    const value = descBairroCtrl.value;

    if (value.length > 30) {
      descBairroCtrl.setErrors({ maxlength: true });
    } else {
      descBairroCtrl.setErrors(null);
    }

    if (this.descBairroOriginal != bairro) {
      return true
    } else {
      return false
    }
  }
  checkUF() {
    if (this.codUfLogradouroOriginal != this.form.value.codUfLogradouro) {
      return true
    } else {
      return false
    }
  }
  checkComplemento() {
    const descComplementoLogradouro = this.form.get('descComplementoLogradouro') as FormControl;
    const value = descComplementoLogradouro.value;

    if (value.length > 40) {
      descComplementoLogradouro.setErrors({ maxlength: true });
    } else {
      descComplementoLogradouro.setErrors(null);
    }

    if(this.form.value.descComplementoLogradouro == '' || this.form.value.descComplementoLogradouro == null) return false
    if(this.descComplementoLogradouroOriginal != this.form.value.descComplementoLogradouro) {
      return true
    } else {
      return false
    }
  }

  checkMunicipio() {
    if (this.form.value.codMunicipioLogradouro == '' || this.form.value.codMunicipioLogradouro == null) {
      return true
    } else {
      return false
    }
  }


  checagens(): boolean{

    let flExist: boolean[] = [];

    if (this.checkCEP()) {
        this.arquivoEnviadoEndereco = false
        this.existDiff = true;
        flExist.push(true);
    }
    if (this.checkTipoLogradouro()) {
        this.arquivoEnviadoEndereco = false
        this.existDiff = true;
        flExist.push(true);
    }
    if (this.checkDescLogradouro()) {
        this.arquivoEnviadoEndereco = false
        this.existDiff = true;
        flExist.push(true);
    }

    if (this.checkNumLogradouro()) {
        this.arquivoEnviadoEndereco = false
        this.existDiff = true;
        flExist.push(true);
    }
    if (this.checkDescBairro()) {
        this.arquivoEnviadoEndereco = false
        this.existDiff = true;
        flExist.push(true);
    }
    if (this.checkUF()) {
        this.arquivoEnviadoEndereco = false
        this.existDiff = true;
        flExist.push(true);
    }

    if (this.checkMunicipio()) {
      this.form.controls['descricaoMunicipioLogradouro'].setErrors({'incorrect': true})
      this.existDiff = true;
      flExist.push(true);
    }
    if (this.checkComplemento()) {
        this.arquivoEnviadoEndereco = false
        this.existDiff = true;
        flExist.push(true);
    }

    if(!flExist.includes(true)){
      if(this.existeAnexoInicial){
        this.arquivoEnviadoEndereco = true;
        this.existDiff = false;
      } else {
        this.existDiff = false;
      }
        return false;
    } else {
      this.toasterService.warning('Atenção: Comprovante de Endereço é obrigatório!');
      this.arquivoEnviadoEndereco = false;
      //this.arquivoSelecionadoEndereco = true;
      this.existDiff = true;
      return true;
    }
  }

  atualizarEndereco() {
    if(this.existDiff){
      return
    }

    if(this.existeAnexoInicial && !this.arquivoEnviadoEndereco){
      this.arquivoEnviadoEndereco = false;
      this.existDiff = true;
      this.toasterService.warning('Atenção: Comprovante de Endereço é obrigatório!');
      return;
    }

    if (this.form.valid) {
      // Lógica para enviar os dados do formulário
      this.enderecoService.atualizarEndereco(this.form.getRawValue()).subscribe(
          (response) => {
            this.toasterService.success('Dados atualizados com sucesso');
            this.dadosSalvos.emit();
            this.formularioSalvo.emit();
          },
          (error) => {
            console.error('Erro ao atualizar os dados', error);
          }
      );
    } else {
      this.toasterService.warning('Atenção: Todos os campos marcados com (*) são obrigatórios!');
    }

  }
  onArquivoExcluidoEndereco(mensagem) {
    const input = document.getElementById('input-file-endereco') as HTMLInputElement;
    if (mensagem) {
      this.toasterService.success('Arquivo excluído com sucesso');
      this.arquivoEnviadoEndereco = false
      //this.arquivoSelecionadoEndereco = null;
      this.existDiff = true;
    } else {
      input.value = '';
      this.arquivoEnviadoEndereco = false
      this.arquivoSelecionadoEndereco = null;
    }

  }

  enviarAnexoEndereco() {
    this.enviandoAnexoEstadoCivil = true
    if (this.arquivoSelecionadoEndereco) {
      this.toasterService.info('Enviando arquivo. Por favor, aguarde.');
      this.enderecoService.salvarEnderecoPessoal(this.arquivoSelecionadoEndereco).subscribe(
        (response) => {
          this.toasterService.success('Arquivo enviado');
          this.arquivoEnviadoEndereco = true
          this.enviandoAnexoEstadoCivil = false
          this.existDiff = false;
          this.fileInputEndereco.nativeElement.value = '';

        },
        (error) => {
          this.fileInputEndereco.nativeElement.value = '';

          this.arquivoEnviadoEndereco = false
          if (error.status == 422) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
          } else {
            this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`);
          }
          this.onArquivoExcluidoEndereco(false)

        }
      );
    }
  }

  onArquivoSelecionado(event: any, TipoDocumento: string) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      switch (TipoDocumento) {
        case 'endereco':
          this.arquivoSelecionadoEndereco = file;
          this.enviarAnexoEndereco();
          break;
      }

    }
    else {
      this.arquivoSelecionadoEndereco = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      this.onArquivoExcluidoEndereco(false)
    }

  }

  avancaParaProximoTab() {
    this.dadosSalvos.emit()

  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

  validarCampo(texto: string): string {
    return MaskUtil.formatToUpperCaseAndOnlyDefaultCaracter(texto);
  }

}
